/**
 * Per-Flavor Yotpo Reviews — combo PDPs
 *
 * Re-mounts the Yotpo main widget against the selected flavor's own product, so the
 * reviews at the bottom of the page match what the shopper picked.
 *
 * Yotpo binds a widget to its element on mount and will not re-read a changed
 * data-product-id, so the div is replaced with a fresh one and initWidgets() is
 * called to mount it. Same flavor detection as the other combo scripts:
 * #callBackVariant class mutations, with #product-select change as fallback.
 */
(function () {
  function init() {
  const container = document.querySelector('[data-flavor-reviews-container]');
  if (!container || container.dataset.flavorReviewsInitialized === 'true') return;
  container.dataset.flavorReviewsInitialized = 'true';

  const dataEl = document.querySelector('[data-flavor-reviews-data]');
  const flavorEl = document.querySelector('[data-flavor-content-data]');
  if (!dataEl || !flavorEl) return;

  let byFlavor, variantFlavors;
  try {
    byFlavor = JSON.parse(dataEl.textContent);
    variantFlavors = JSON.parse(flavorEl.textContent);
  } catch (e) {
    return;
  }

  const select = document.getElementById('product-select');
  let currentId = container.querySelector('.yotpo')?.dataset.productId || null;

  /** Yotpo's loader is async; don't drop a swap that lands before it arrives. */
  function mount(attempt) {
    if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
      window.yotpo.initWidgets();
      return;
    }
    if ((attempt || 0) < 20) setTimeout(() => mount((attempt || 0) + 1), 400);
  }

  function update() {
    if (!select) return;
    const key = variantFlavors[select.value];
    if (!key) return;

    const p = byFlavor[key];
    if (!p || String(p.id) === String(currentId)) return; // same product, nothing to do
    currentId = String(p.id);

    // A mounted Yotpo widget ignores attribute changes, so replace the node.
    const fresh = document.createElement('div');
    fresh.className = 'yotpo yotpo-main-widget';
    fresh.dataset.productId = p.id;
    fresh.dataset.name = p.name || '';
    fresh.dataset.url = p.url || '';
    fresh.dataset.imageUrl = p.image || '';
    fresh.dataset.price = p.price || '';
    fresh.dataset.currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

    // replaceChildren rather than innerHTML: every value here comes from our own
    // Liquid-serialised JSON, but node APIs keep it that way by construction.
    container.replaceChildren(fresh);
    mount(0);
  }

  const cbv = document.getElementById('callBackVariant');
  if (cbv) {
    new MutationObserver(update).observe(cbv, { attributes: true, attributeFilter: ['class'] });
  }
  if (select) select.addEventListener('change', update);
  }

  init();
  document.addEventListener('nc:combined-product:loaded', init);
})();
